<template>
    <Loading>
        <Row class="header mb-3" />
        <Row />
        <Row />
        <Row class="w-75" />
        <Row class="header mt-5 mb-3" />
        <Row />
        <Row />
        <Row class="w-75" />
        <Row class="w-75" />
        <Row class="w-75" />
    </Loading>
</template>

<script>
import Loading from './base/Loading';
import Row from './base/Row';
export default {
    components: { Loading, Row },
};
</script>

<style scoped>
.header {
    height: 2rem;
}
</style>
